import { API_URLS_LIST } from '@config/api-config';
import axiosInstance from '@services/api/axios-wrapper-service';

export const pharmacyAllPrescriptions = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.pharmacyAllPrescriptions, request);
};

export const pharmacyAllOrders = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.pharmacyAllOrders, request);
};

export const getOrderDetails = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getOrderDetails, request);
};

export const addressHistory = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.addressHistory, request);
};

export const pharmacyAddresses = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.pharmacyAddresses, request);
};

export const pharmacyContactDetails = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.pharmacyContactDetails, request);
};

export const getPaymentDetails = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPaymentDetails, request);
};

export const getContactDetails = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPharmacyContactDetails, request);
};

export const updateContactDetails = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.updatePharmacyContactDetails, request);
};

export const getPharmacyShippingOptions = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPharmacyShippingOptions, request);
};

export const getCommunicationPreferences = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getCommunicationPreferences, request);
};

export const saveCommunicationPreferences = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.saveCommunicationPreferences, request);
};



export const getPharmacyAllergies = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPharmacyAllergies, request);
};

export const getPharmacyDefaultAllergies = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPharmacyDefaultAllergies, request);
};

export const getAllergiesByName = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getAllergiesByName, request);
};

export const archivePrescription = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.archivePrescriptions, request);
};
export const UnArchivePrescription = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.unArchivePrescriptions, request);
};
export const getArchivePrescriptionList = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getArchivedPrescriptions, request);
};
export const getRefillsHistory = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getRefillsHistory, request);
};
export const updatePharmacyAllergies = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.updatePharmacyAllergies, request);
}

export const deleteDeliveryAddress = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.deleteDeliveryAddress, request);
};

export const addDeliveryAddress = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.addDeliveryAddress, request);
};

export const updateDeliveryAddress = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.updateDeliveryAddress, request);
};

export const validateAddress = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.validateAddress, request);
}

export const getPharmacyOutstandingBalance = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPharmacyOutstandingBalance, request);
}

export const getSpecialtyQuestionnaire = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getSpecialtyQuestionnaire, request);
}

export const submitRefillRenew = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.submitRefillRenew, request);
}

export const getPaymentMethod = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getPaymentMethod, request);
}

export const deletePaymentMethod = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.deletePaymentMethod, request);
}

export const addUpdatePaymentMethod = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.addUpdatePaymentMethod, request);
}

export const getRxMemberEligibility = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getRxMemberEligibility, request);
}

export const submitQuestionnaireAnswerResponse = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.submitQuestionnaireAnswerResponse, request);
}